import { Component, OnInit, Input } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { TinymceComponent } from '../../editors/tinymce/tinymce.component';

// import { UscStoreService } from '../../../services/usc-store/usc-store.service';
import { ApiService } from '../../../services';
import { Observable } from 'rxjs';
// import { UscAttachmentLookupComponent } from '../attachment-lookup/usc-attachment-lookup.component';

@Component({
    selector: 'sn-email-composer',
    templateUrl: './email-composer.component.html',
    styleUrls: ['./email-composer.component.css'],
    // host: {
    //   '[style.display]': '"flex"',
    //   '[style.flex-direction]': '"column"',
    //   '[style.overflow]': '"hidden"'    
    // }
})
export class EmailComposerComponent implements OnInit {
    @Input() view: string;
    @Input() view_item_ID: any;
    @Input() view_item_type: string;
    @Input() emailTemplates: Array<any>;
    @Input() curr_event: any;
    @Input() editor_settings: any;
    // @Input() sendEmailTemplate: Function;
    @Input() composer_settings: any;

    public modal_status: string = "modal_loading";

    public currentTemplate: any;
    public selectedTemplateID: any;
    public tinymce_settings: any;
    public settings: any;
    public is_send_email: boolean;

    constructor(
        public ngbModal: NgbModal,
        public activeModal: NgbActiveModal,
        public apiService: ApiService

    ) { }

    ngOnInit() {
        this.is_send_email = false;
        this.currentTemplate = this.emailTemplates[0];
        this.selectedTemplateID = this.currentTemplate.ID;
        this.tinymce_settings = { height: 300, menubar: '', toolbar: ' ' }
        if (this.editor_settings) this.tinymce_settings = this.editor_settings;
        this.settings = { close_on_sent: true, is_subject_readonly: true, allow_attachment: false, show_email_templates: this.emailTemplates.length > 1 }
        if (this.composer_settings) {
            if (this.composer_settings.is_subject_readonly != null) this.settings.is_subject_readonly = this.composer_settings.is_subject_readonly;
            if (this.composer_settings.close_on_sent != null) this.settings.close_on_sent = this.composer_settings.close_on_sent;
            if (this.composer_settings.allow_attachment != null) this.settings.allow_attachment = this.composer_settings.allow_attachment;
            if (this.composer_settings.show_email_templates != null) this.settings.show_email_templates = this.composer_settings.show_email_templates;
        }

        this.applyEmailTemplate();
    }

    onChange(event) {
        this.applyEmailTemplate();
    }

    applyEmailTemplate() {
        this.apiService.translateEmailTemplate(this.selectedTemplateID, this.view_item_type, this.view_item_ID).subscribe(
            template => {
                this.currentTemplate = template;
                this.modal_status = "modal_loaded";
            }
        );
    }

    sendEmail() {
        this.is_send_email = true;
        this.currentTemplate.is_body_html = "Y";

        var related_type = '';
        switch (this.view_item_type) {
            case 'company': related_type = 'CU'; break;
            case 'contact': related_type = 'CO'; break;
            case 'lead': related_type = 'LD'; break;
            case 'deal': related_type = 'DL'; break;
            case 'case': related_type = 'CS'; break;
            case 'call': related_type = 'CA'; break;
            case 'meeting': related_type = 'ME'; break;
            case 'task': related_type = 'TA'; break;
        }

        var params = { save_as_em: true, related_ID: this.view_item_ID, related_type: related_type }
        this.apiService.sendEmailTemplate(this.currentTemplate, this.emailAttachments, params).subscribe(
            result => { 
                this.is_send_email = false;
                if (this.settings.close_on_sent) this.activeModal.close(true); 
            }
        );
    }

    cancel() {
        this.activeModal.dismiss();
    }

    isFileUploading: boolean = false;
    emailAttachments: any[] = [];
    uploadFile(event) {
        this.isFileUploading = true;
        let file = event.target.files[0];
        let formData = new FormData();
        formData.append("filename", file.name);
        formData.append("file", file);
        event.target.value = null;
        this.apiService.postFile("/models/file/upload", formData).subscribe(
            result => {
                this.isFileUploading = false;
                this.emailAttachments.push(result);
            }
        );
    }

    removeAttachment(attachment, index) {
        this.emailAttachments.splice(index, 1);
    }

    showAttachments(item) {
        // const modalRef = this.ngbModal.open(UscAttachmentLookupComponent, { size: "lg", backdrop: 'static', keyboard: false });
        // modalRef.componentInstance.view = this.view;
        // modalRef.componentInstance.related_type = "contact";
        // modalRef.componentInstance.related_ID = item.co_ID;
        // modalRef.componentInstance.data = item;
        // modalRef.componentInstance.mode = "picker";    
        // modalRef.result.then((result) => {
        //   console.log(result);
        //   if (result && result.selectedItem) this.emailAttachments.push(result.selectedItem);
        //   }, (reason) => {
        //   console.log('Attachment Closed');
        // });
    }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/common/email-composer/email-composer.component.ts